import { createStore, combineReducers, compose } from "redux";

import auth from "./auth/reducer";
import invoices from "./invoices/reducer";
import inventories from "./inventories/reducer";
import orders from "./orders/reducer";
import pendingInventory from "./pendingInventory/reducer";
import purchaseOrders from "./purchaseOrders/reducer";
import priceLists from "./priceLists/reducer";
import shipments from "./shipments/reducer";
import creditNotes from "./creditNotes/reducer";
import sessions from "./sessions/reducer";
import reports from "./reports/reducer";
import marketInventory from "./marketInventory/reducer";
import maintenance from "./maintenance/reducer";
import providerPortal from "./providerPortal/reducer";

const rootReducer = combineReducers({
  auth,
  invoices,
  inventories,
  orders,
  pendingInventory,
  purchaseOrders,
  priceLists,
  shipments,
  creditNotes,
  sessions,
  reports,
  marketInventory,
  maintenance,
  providerPortal,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers());

export default store;
